<template>
  <div>
    <div v-if="isEditor">
      <div v-for="(user, index) in notification.users" :key="index">
        <notificationUser
          :indexProperty="index"
          :userProperty="user"
          :doEditProperty="true"
          @deleteuser="deleteUser"
          @moveuser="moveUser"
        ></notificationUser>
      </div>
      <div class="d-flex flex-row justify-content-around mt-3">
        <button
          class="btn btn-outline-dark"
          @click="addNotificationUserByEmail('')"
        >
          <i class="fas fa-plus"></i>
        </button>
        <button class="btn btn-outline-dark" @click="save()">
          <i class="fas fa-save"></i>
        </button>
        <button class="btn btn-outline-dark" @click="cancel()">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div v-if="!isEditor">
      <div class="d-flex flex-column">
        <ul class="list-group w-100">
          <div v-for="(user, index) in notification.users" :key="index">
            <li class="list-group-item">
              {{ user.email && user.email }}
              {{ user.firstName && user.firstName }}
              {{ user.lastName && user.lastName }}
            </li>
          </div>
        </ul>
        <div class="d-flex flex-row justify-content-around mt-3">
          <button class="btn btn-outline-dark" @click="switchEditMode(true)">
            <i class="fas fa-edit"></i> Bearbeiten
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emptyNotificationUser } from "@/common/constants";
import notificationUser from "@/components/notification/NotificationUser.vue";
export default {
  name: "notification",
  components: {
    notificationUser
  },
  data: function() {
    return {
      isEditor: false,
      notification: { users: [] },
      oldValue: ""
    };
  },
  mounted() {
    console.info("created");
    this.decodeNotifications();
    this.oldValue = this.value;
  },
  watch: {},
  methods: {
    addNotificationUser(user) {
      this.removeNotification(user.email);
      this.notification.users.push(user);
      this.encodeNotifications();
    },
    addNotificationUserByEmail(email) {
      var newUser = JSON.parse(JSON.stringify(emptyNotificationUser));
      newUser.email = email;
      this.addNotificationUser(newUser);
    },
    removeNotification(email) {
      var index = 0;
      for (const user of this.notification.users) {
        if (user.email == email) {
          this.notification.users.splice(index, 1);
          this.encodeNotifications();
          return user;
        }
        ++index;
      }
      return null;
    },
    decodeNotifications() {
      console.info("decode from:" + this.value);
      if (!this.value) {
        this.notification = { users: [] };
      } else if (this.value.charAt(0) == "{") {
        this.notification = JSON.parse(this.value);
        if (!this.notification.users) {
          this.notification = { users: [] };
        }
      } else {
        this.notification = { users: [] };
        var emails = this.value.split(",");

        for (const email of emails) {
          this.addNotificationUserByEmail(email);
        }
      }
    },
    encodeNotifications() {
      console.info("decode from:" + this.value);
      this.text = JSON.stringify(this.notification);
    },
    switchEditMode(on) {
      this.isEditor = on;
    },
    save() {
      this.encodeNotifications();
      this.oldValue = this.value;
      this.switchEditMode(false);
      this.$emit("savenotification", this.journalEntry);
    },
    cancel() {
      this.value = this.oldValue;
      this.decodeNotifications();
      this.switchEditMode(false);
    },
    // eslint-disable-next-line
    deleteUser(index, up) {
      var user = this.notification.users[index];
      if (user) {
        this.notification.users.splice(index, 1);
        this.encodeNotifications();
      }
    },
    moveUser(index, down) {
      var user = this.notification.users[index];
      if (user) {
        if (down && index + 1 < this.notification.users.length) {
          this.notification.users.splice(index, 1);
          this.notification.users.splice(index + 1, 0, user);
          console.info("inserted user at " + (index + 1));
        }
        if (!down && index > 0) {
          this.notification.users.splice(index, 1);
          this.notification.users.splice(index - 1, 0, user);
          console.info("inserted user at " + (index - 1));
        }
        this.encodeNotifications();
      }
    }
  },
  props: {
    value: String
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
